import React from "react";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://github.com/dipakshinde-art/" target="_blank">
                <i className="fa fa-github-square"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/dipak-shinde-2857461b6/"
                target="_blank"
              >
                <i className="fa fa-linkedin-square"></i>
              </a>
              <a
                href="https://www.instagram.com/mr_d_i_p_a_k____/"
                target="_blank"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a href="https://twitter.com/mr_D_17" target="_blank">
                <i className="fa fa-twitter"></i>
              </a>
            </div>
          </div>

          <div className="profile-details-name">
            <span className="primary-text">
              Hello stranger! 👋 it's
              <span className="highlighted-text"> Dipak Shinde</span>
            </span>
          </div>

          <div className="profile-details-role">
            <span className="primary-text">
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiastic Developer",
                    1000,
                    "Full Stack Web Developer",
                    1000,
                    "MERN Stack Developer",
                    1000,
                    "React Developer",
                    1000,
                    "Node/Express Developer",
                    1000,
                  ]}
                />
              </h1>
              <span className="profile-role-tagline">
                {/* Passion-driven learner and a web developer with the ability
                <br></br> to write clean,reusable, optimised code .<br></br>
                Looking forward to joining a progressive and challenging work
                environment. */}
                As a passion-fueled web developer, I craft clean, reusable, and
                optimized code, <br></br> always striving to push the boundaries of what's
                possible.<br></br> My journey is driven by a thirst for learning and a
                relentless pursuit of excellence. <br></br>I'm eager to contribute to a
                dynamic and forward-thinking environment<br></br> where challenges are
                embraced as opportunities for growth and innovation
              </span>
            </span>
          </div>
          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              Hire Me
            </button>
            <a href="resume.pdf" download="Dipak Shinde.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
